<div class="w-full h-full overflow-auto" *ngIf="assetFileData">
  <ng-template ngFor let-ratio [ngForOf]="assetFileData.aspectRatios" let-i="index">
    <ng-template [ngIf]="ratio">
      <div [ngClass]="{ 'border-2 border-red-600': ratio.selected }" class="card-view bg-white m-3 h-[285px] inline-block cursor-pointer rounded-lg overflow-hidden shadow hover:shadow-xl">
        <div class="asset-image-box h-[240px] flex relative rounded-lg overflow-hidden" (click)="emitAspectRatio(ratio)">
          <img
            *ngIf="ratio.currentPreviewUrl"
            class="object-contain h-full m-auto"
            [src]="ratio.currentPreviewUrl | imageLoading | async"
            [alt]="ratio.aspectRatio"
            [style.pointerEvents]="!(assetData.expiryDate | dateNotExpired) ? 'none' : 'all'"
          />
          <div class="h-full w-full flex justify-center items-center" *ngIf="!ratio.currentPreviewUrl && (assetData?.expiryDate | dateNotExpired)">
            <span class="text-xl font-bold m-6" i18n>Preview Not Available</span>
          </div>
          <!-- Overlay for expired assets  -->
          <sp-overlay class="asset-overlay-semitransparent" *ngIf="!(assetData.expiryDate | dateNotExpired)">
            <span class="text-xl font-bold" i18n>Expired</span>
          </sp-overlay>
        </div>
        <div class="flex justify-between content-center">
          <p class="pl-2 pt-2 truncate w-[85%] inline-block" i18n>
            {{ ratio.aspectRatioName ? 'Aspect ratio: ' + ratio.aspectRatioName : 'Default format' }}
          </p>
          <button *ngIf="(AccessAsset(assetData) | can : 'update') && i !== 0" mat-icon-button i18n-matTooltip matTooltip="Delete" (click)="deleteAspect(ratio)">
            <mat-icon class="material-icons-outlined">delete</mat-icon>
          </button>
        </div>
      </div>
    </ng-template>
  </ng-template>
</div>
